module.exports = __webpack_public_path__ + "static/media/ela_ada.3e4fe992.jpg";